import firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/auth'
import 'firebase/firestore'


const devCreds = {
    apiKey: "AIzaSyAkezitWafbtFdUlB-9xVbZd71dGN4EPZc",
    authDomain: "gravy-rs-interface-staging.firebaseapp.com",
    projectId: "gravy-rs-interface-staging",
    storageBucket: "gravy-rs-interface-staging.appspot.com",
    messagingSenderId: "605379107362",
    appId: "1:605379107362:web:72979def52a6c57ae2487b",
    measurementId: "G-N8PTJMPXRB"
}

const prodCreds = {
    apiKey: "AIzaSyC3k6r4P3X08d2eujK92sRKbL65q-kjyNU",
    authDomain: "v1-prod-318216.firebaseapp.com",
    projectId: "v1-prod-318216",
    storageBucket: "v1-prod-318216.appspot.com",
    messagingSenderId: "591488808578",
    appId: "1:591488808578:web:d5ad303b7175754622269b"
}
if (process.env.NODE_ENV === "staging" || process.env.NODE_ENV === "development") {
    firebase.initializeApp(devCreds)
} else {
    firebase.initializeApp(prodCreds)
}

